<template>
  <div class="api-browser" :class="{ fullscreen }">
    <header>
      <h4>
        <svg class="v-mid" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3DD143" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="bevel">
          <polyline points="16 18 22 12 16 6"></polyline>
          <polyline points="8 6 2 12 8 18"></polyline>
        </svg>
        <span class="v-mid ml2 text-extra-bold">
          {{ title }} <span class="fa-solid icon-compress"></span>
        </span>
      </h4>

      <div class="icons-container">
        <transition name="fade">
          <span class="message" v-if="message">{{ message }}</span>
        </transition>
        <i @click="copy" @mouseover="showMsg('copy')" class="icon-copy" />
        <i @mouseover="showMsg('toggle fullscreen')" @click="fullscreen = !fullscreen" :class="fullscreen ? 'dnsimple-contract' : 'dnsimple-expand'" />
      </div>
    </header>

    <div class="flex h-100">
      <nav class="sidebar w-30 w-20-ns bg-near-black" v-if="showSidebar">

        <ul>
          <li class="text-italic">Libraries</li>
          <li :key="lang.key" v-for="lang in languages" @click="langKey = lang.key" class="lang pointer flex items-center" :class="{ active: langKey === lang.key }">
            <LangIcon class="mr2" :lang="lang.key" />
            <span class="v-mid">{{ lang.label }}</span>
          </li>
        </ul>
      </nav>

      <div :class="showSidebar ? 'w-80' : 'w-100'">
        <LanguageExamples @exampleChanged="onExampleChanged" :lang="langKey" />
      </div>
    </div>
  </div>
</template>

<script>
import LangIcon from './lang-icon.vue';
import LanguageExamples from './language-examples.vue';
import Languages from './languages.js';

export default {
  components: {
    LanguageExamples,
    LangIcon
  },

  props: {
    lang: { type: String, default: Object.keys(Languages)[0] },
    title: { type: String, default: 'API Browser' },
    showSidebar: { type: Boolean, default: false }
  },

  computed: {
    selectedLang() {
      return this.languages.find(({ key }) => key === this.langKey);
    }
  },

  watch: {
    fullscreen() {
      if (this.fullscreen) document.body.style = 'overflow: hidden;';
      else document.body.removeAttribute('style');
    }
  },

  methods: {
    onExampleChanged(example) {
      this.currentExample = example;
    },

    copy() {
      navigator.clipboard.writeText(this.currentExample);
      this.showMsg('copied!');
    },

    showMsg(msg) {
      this.message = msg;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.message = null;
      }, 1200);
    }
  },

  data() {
    return {
      timer: null,
      currentExample: null,
      message: null,
      fullscreen: false,
      langKey: this.lang,
      languages: Object.entries(Languages)
        .map(([key, value]) => ({ ...value, key }))
        .filter((lang) => lang.browser)
    };
  }
};
</script>
